import { FC } from "react";
import { NewsCard } from "./NewsCard/NewsCard";
import { CommunityOutreach } from "./CommunityOutreach/CommunityOutreach";
import NewsData from "./News.json";
import CommunityOutreachData from "./CommuntyOutreach.json";
import "./News.scss";

interface INewsItem {
  title: string;
  date: string;
  content: any[];
}

interface ICommunitryOutreachOrganization {
  name: string;
  logo: string;
  content: string;
  link: string;
}

export const News: FC = () => {
  return (
    <div className="News">
      <div className="News__header page-header">
        <h1>News and Awards</h1>
        <p>
          PROSOFT is proud of our history as a responsible small business and
          valued IT Services and Engineering contractor to the DOD, Federal, and
          State/Local Government agencies and entities. Our Executive Leadership
          is committed to continuing quality services, generating new news and
          achieving contract awards and corporate accomplishments to share with
          industry and community.
        </p>
      </div>
      <div className="News__body">
        <div className="News__body__section">
          <h2 className="section-header">Recent Awards</h2>
          <div className="News__body__section__content">
            {(() => {
              let year: string = "";
              return NewsData.news.map((item: INewsItem) => {
                const newsYear: string = item.date.slice(-4);
                if (newsYear !== year) {
                  year = newsYear;

                  return (
                    <>
                      <span className="watermark">{year}</span>
                      <NewsCard
                        title={item.title}
                        date={item.date}
                        content={item.content}
                      />
                    </>
                  );
                } else {
                  return (
                    <NewsCard
                      title={item.title}
                      date={item.date}
                      content={item.content}
                    />
                  );
                }
              });
            })()}
          </div>
        </div>
        <div className="News__body__section">
          <h2 className="section-header">Community Outreach</h2>
          <div className="News__body__section__content">
            <p className="section-subheader">
              PROSOFT not only prides itself on treating employees as members of
              a family, but we consider members of our community as family. Our
              reward is the warmth and appreciation shown to us by our community
              and the idea of bringing some relief to those in need.
            </p>
            <p className="section-subheader">Who we support</p>
            <div className="CommunityOutreachOrganizations">
              {CommunityOutreachData.organizations.map(
                (org: ICommunitryOutreachOrganization) => {
                  return (
                    <CommunityOutreach
                      name={org.name}
                      logo={org.logo}
                      content={org.content}
                      link={org.link}
                    />
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
